import { mode } from "@chakra-ui/theme-tools";

const fieldStyles = (props) => ({
  bg: mode("white", "navy.700")(props),
  color: mode("gray.800", "white")(props),
  border: "1px solid",
  borderColor: mode("gray.200", "whiteAlpha.300")(props),
  borderRadius: "8px",
  _placeholder: { color: mode("gray.500", "whiteAlpha.600")(props) },
  _hover: {
    borderColor: mode("gray.300", "whiteAlpha.400")(props),
    bg: mode("gray.50", "navy.600")(props),
  },
  _focusVisible: {
    borderColor: mode("brand.500", "brand.300")(props),
    bg: mode("white", "navy.700")(props),
    color: mode("gray.800", "white")(props),
    boxShadow: mode(
      "0 0 0 1px var(--chakra-colors-brand-500)",
      "0 0 0 1px var(--chakra-colors-brand-300)",
    )(props),
  },
});

export const inputStyles = {
  components: {
    Input: {
      baseStyle: (props) => ({
        field: {
          ...fieldStyles(props),
          fontWeight: 400,
        },
      }),
      defaultProps: {
        variant: "outline",
      },
      variants: {
        outline: (props) => ({
          field: fieldStyles(props),
        }),
        main: (props) => ({
          field: {
            ...fieldStyles(props),
            borderRadius: "16px",
            fontSize: "sm",
            p: "20px",
          },
        }),
        auth: (props) => ({
          field: {
            ...fieldStyles(props),
            fontWeight: "500",
            borderRadius: "16px",
          },
        }),
        authSecondary: (props) => ({
          field: {
            ...fieldStyles(props),
            bg: mode("transparent", "navy.800")(props),
            borderRadius: "16px",
          },
        }),
        search: (props) => ({
          field: {
            ...fieldStyles(props),
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _hover: {
              bg: mode("secondaryGray.300", "navy.600")(props),
            },
          },
        }),
      },
    },
    NumberInput: {
      baseStyle: (props) => ({
        field: {
          ...fieldStyles(props),
          fontWeight: 400,
        },
      }),
      defaultProps: {
        variant: "outline",
      },
      variants: {
        outline: (props) => ({
          field: fieldStyles(props),
        }),
      },
    },
    Select: {
      baseStyle: (props) => ({
        field: {
          ...fieldStyles(props),
          fontWeight: 400,
        },
        icon: {
          color: mode("gray.500", "gray.300")(props),
        },
      }),
      defaultProps: {
        variant: "outline",
      },
      variants: {
        outline: (props) => ({
          field: fieldStyles(props),
          icon: {
            color: mode("gray.500", "gray.300")(props),
          },
        }),
        main: (props) => ({
          field: {
            ...fieldStyles(props),
            borderRadius: "16px",
          },
          icon: {
            color: mode("gray.500", "gray.300")(props),
          },
        }),
        mini: (props) => ({
          field: {
            ...fieldStyles(props),
            border: "0px solid transparent",
            fontSize: "0px",
            p: "10px",
          },
        }),
        subtle: (props) => ({
          field: {
            bg: "transparent",
            border: "0px solid",
            color: mode("secondaryGray.600", "white")(props),
            width: "max-content",
            _placeholder: { color: mode("secondaryGray.600", "whiteAlpha.600")(props) },
          },
          icon: {
            color: mode("secondaryGray.600", "gray.300")(props),
          },
        }),
        transparent: (props) => ({
          field: {
            bg: "transparent",
            border: "0px solid",
            color: mode("secondaryGray.600", "white")(props),
            padding: "0px",
            paddingLeft: "8px",
            paddingRight: "20px",
            fontWeight: "700",
            fontSize: "14px",
          },
        }),
        auth: (props) => ({
          field: fieldStyles(props),
        }),
        search: (props) => ({
          field: {
            ...fieldStyles(props),
            border: "none",
            py: "11px",
          },
        }),
      },
    },
  },
};
